import request from '@/plugins/ecommerce_axios'
import requestAdmin from '@/plugins/admin_axios'
export const CreateUserApi = async (data) => {
  const formData = new FormData()
  for (let key in data) {
    formData.append(key, data[key])
  }
  const response = await request.post('user/register/', formData)
  return response.data
}

export const ListUsersAdminApi = async (data) => {
  const response = await requestAdmin.get('user/list/', { params: data })
  return response.data
}

export const ListPerfisApi = async () => {
  const response = await requestAdmin.get('user/perfil/list/')
  return response.data
}